module.exports = __webpack_public_path__ + "img/logo-big.851bf3df.png";